import { fetchService } from "./baseService";

export const fetchLinkDetailsByHash = (hash) =>
    fetchService(`public/listing/${hash}`, {
        method: "GET",
    });

export const fetchLinkDetailsByPublicId = (publicId) =>
fetchService(`public/listing/publicid/${publicId}`, {
    method: "GET",
});